<template>
    <div class="z-copyright">
        <span>&copy;</span>
        <span
            v-if="text"
            class="z-copyright__text"
        >{{copyrightText}}</span>
        <!-- <span class="z-copyright__years">
            <span
                v-if="year"
                class="z-copyright__year-start"
            >
                {{ this.year }}
            </span>
            {{hyphen}}
            <span
                v-if="yearCurrent"
                class="z-copyright__year-current"
            >
                {{ currentYear }}
            </span>
        </span> -->
    </div>
</template>

<script>
export default {
    name: 'z-copyright',
    props: {
        text: String,
        yearCurrent: Boolean,
        year: [String, Number]
    },
    data () {
        return {
            lang: this.$root.lang
        }
    },
    computed: {
        currentYear () {
            return new Date().getFullYear()
        },
        hyphen () {
            return this.year && this.yearCurrent ? '—' : ''
        },
        copyrightText () {
            return this.lang === 'ru'
                ? `${this.text}, ${this.currentYear}`
                : `${this.currentYear} ${this.text}`
        }
    }
}
</script>

<style lang="scss">
    .z-copyright {
        font-size: 14px;
        color: $token-colors-black-70;

        @include breakpoint (laptop) {
            font-size: 12px;
        }
    }
</style>
